import { gql } from "@apollo/client";

export const PERSON_NAME_FIELDS = gql`
  fragment PersonNameFields on HumanName {
    family
    prefix
    given
    use
  }
`;

export const PERSON_REFERENCE =  gql`
fragment PersonReference on Reference {
  reference
}
  ${PERSON_NAME_FIELDS}
`;
export const PERSON_REFERENCE_FIELDS = gql`
  fragment PersonReferenceFields on Reference {
    reference
    resource {
      ... on Patient {
        id
        name {
          ...PersonNameFields
        }
      }
      ... on Practitioner {
        id
        name {
          ...PersonNameFields
        }
      }
    }
  }
  ${PERSON_NAME_FIELDS}
`;

export const OBSERVATION_FIELDS = gql`
  fragment ObservationFields on Observation {
    id
    status
    code {
      coding {
        code
        display
        system
      }
    }
    subject {
      reference
    }
    component {
      code {
        coding {
          code
          system
          display
        }
      }
    }
    referenceRange {
      low {
        value
        unit
      }
      high {
        value
        unit
      }
    }
  }
`;

export const DIAGNOSTIC_REPORT_FIELDS = gql`
  fragment DiagnosticReportFields on DiagnosticReport {
    id
    status
    code {
      coding {
        code
        display
        system
      }
    }
    subject {
      reference
    }
    issued
    performer {
      reference
    }
    result {
      reference
      resource {
        ... on Observation {
          ...ObservationFields
        }
      }
    }
  }
  ${OBSERVATION_FIELDS}
`;

export const DOCUMENT_REFERENCE_FIELDS = gql`
  fragment DocumentReferenceFields on DocumentReference {
    id
    type {
      coding {
        display
        code
        system
      }
    }
    description
    status
    docStatus
    subject {
      ...PersonReference
    }
    content {
      attachment {
        url
        size
        title
        creation
        contentType
        data
        hash
      }
    }
    context {
      related {
        reference
        resource {
          ... on DiagnosticReport {
            ...DiagnosticReportFields
          }
        }
      }
      period {
        start
        end
      }
    }
    meta {
      tag {
        code
        display
        system
      }
    }
  }
  ${PERSON_REFERENCE}
  ${DIAGNOSTIC_REPORT_FIELDS}
`;

//  Notes : Need to add the requestor and owner later
// requester {
//   ...PersonReferenceFields
// }
// owner {
//   ...PersonReferenceFields
// }
export const TASK_FIELDS = gql`
  fragment TaskFields on Task {
    id
    identifier {
      value
    }
    meta {
      lastUpdated
      accounts {
        reference
      }
    }
    businessStatus {
      coding {
        code
        display
        system
      }
    }
    intent
    status
    for {
      ...PersonReferenceFields
    }
    owner {
      ...PersonReferenceFields
    }
    focus {
      reference
      resource {
        ... on DocumentReference {
          ...DocumentReferenceFields
        }
      }
    }
    input {
      type {
        text
      }
      valueString
    }
    output {
      type {
        coding {
          code
          display
        }
      }
      valueString
    }
  }
  ${PERSON_REFERENCE_FIELDS}
  ${DOCUMENT_REFERENCE_FIELDS}
`;
